/*
 * ProjectActivityListPage Messages
 *
 * This contains all the text for the ProjectsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  noNote: {
    id: `${scope}.noNote`,
    defaultMessage: 'No note added',
  },
  noType: {
    id: `${scope}.noType`,
    defaultMessage: 'No publish type',
  },
  publicationVersion: {
    id: `${scope}.status`,
    defaultMessage: 'Publications versions',
  },
  ePub: {
    id: `${scope}.ePub`,
    defaultMessage: 'ePub',
  },
  downloadReport: {
    id: `${scope}.downloadReport`,
    defaultMessage: 'Download Report',
  },
  selectVersions: {
    id: `${scope}.selectVersions`,
    defaultMessage: 'Select two version to compare',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: 'Continue',
  },
  cancel: {
    id: `${scope}.canel`,
    defaultMessage: 'Cancel',
  },
  versionChanges: {
    id: `${scope}.versionChanges`,
    defaultMessage: 'Version Changes',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  noChange: {
    id: `${scope}.noChange`,
    defaultMessage: 'No changes detected for the selected two versions',
  },
});
